export default __webpack_public_path__ + "static/media/UY.8d459912.svg";